module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/49977a0d3680d3a72955df57e5a15afb.svg";